import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useChat } from "../../../context/ChatContext.jsx";

function MarketNavbar() {
  const [open, setOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isLoggedIn, location: userLocation, logout } = useAuth();
  const { unreadCount } = useChat();

  const isActive = (to) => location.pathname.startsWith(to);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="market-navbar">
      <div className="nav-inner">
        <Link className="brand" to="/services">
          timquanhday
        </Link>

        <button
          className="nav-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`nav-center ${open ? "open" : ""}`}>
          <Link
            className={`nav-link ${isActive("/services") ? "active" : ""}`}
            to="/services"
          >
            Dịch vụ
          </Link>
          <Link
            className={`nav-link ${
              isActive("/market/thanh-ly") ? "active" : ""
            }`}
            to="/market/thanh-ly"
          >
            Thanh lý
          </Link>
          <Link
            className={`nav-link ${
              isActive("/market/hoat-dong") ? "active" : ""
            }`}
            to="/market/hoat-dong"
          >
            Hoạt động
          </Link>
          <Link
            className={`nav-link ${isActive("/group") ? "active" : ""}`}
            to="/group"
          >
            Diễn đàn
          </Link>
        </nav>

        <div className="nav-actions">
          {/* Location from AuthContext */}
          <div className="location">
            <span className="ico">📍</span>
            <span className="location-text">
              {userLocation || "Đang tải..."}
            </span>
          </div>

          <button className="icon-btn" title="Thông báo">
            🔔
          </button>
          <Link to="/message" className="relative">
            <button className="icon-btn" title="Tin nhắn">
              💬
            </button>
            {unreadCount > 0 && (
              <span
                className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] min-w-[16px] h-[16px] px-[4px] rounded-full flex items-center justify-center"
                aria-label={`Bạn có ${unreadCount} tin nhắn chưa đọc`}
              >
                {unreadCount}
              </span>
            )}
          </Link>

          {/* User Menu */}
          <div className="user-menu-wrapper">
            <button
              className="icon-btn user-btn"
              title={isLoggedIn ? user?.Username || "Tài khoản" : "Tài khoản"}
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              👤
            </button>

            {showUserMenu && (
              <div className="user-dropdown">
                {isLoggedIn && (
                  <>
                    <div className="user-info">
                      <p className="username">{user?.Username}</p>
                      <p className="email">{user?.Email}</p>
                    </div>
                    <hr className="divider" />
                    <button
                      className="dropdown-item"
                      onClick={() => navigate("/profile")}
                    >
                      👤 Trang cá nhân
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => navigate("/settings")}
                    >
                      ⚙️ Cài đặt
                    </button>
                    <hr className="divider" />
                    <button
                      className="dropdown-item logout"
                      onClick={handleLogout}
                    >
                      🚪 Đăng xuất
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Local CSS */}
      <style>{`
        .market-navbar { 
          position: sticky; top: 0; z-index: 50;
          background: rgb(18,37,39);
          border-bottom: 1px solid rgba(80,199,89,0.35);
        }
        .nav-inner { 
          max-width: 1200px; margin: 0 auto; padding: 10px 16px; 
          display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; gap: 12px;
        }
        .brand { 
          font-weight: 700; letter-spacing: 0.4px; text-decoration: none; 
          color: #9ae6b4; font-size: 22px; font-family: 'Lexend', sans-serif;
        }
        .nav-toggle { display: none; width: 36px; height: 32px; background: transparent; border: 0; cursor: pointer; }
        .nav-toggle span { display: block; height: 2px; background: #9fb3c8; margin: 6px 0; border-radius: 2px; }

        .nav-center { 
          display: flex; justify-content: center; align-items: center; gap: 22px;
        }
        .nav-link { 
          color: #cbd5e1; text-decoration: none; font-size: 13px; opacity: 0.85; 
          padding: 8px 0; position: relative; transition: color .2s, opacity .2s;
        }
        .nav-link:hover { color: #e5e7eb; opacity: 1; }
        .nav-link.active::after { 
          content: ""; position: absolute; left: 0; right: 0; bottom: -10px; height: 2px; 
          background: #86efac; border-radius: 2px;
        }

        .nav-actions { 
          display: flex; justify-content: flex-end; align-items: center; gap: 10px;
        }
        .location { display: none; color: #9fb3c8; align-items: center; gap: 6px; font-size: 13px; }
        .location .ico { filter: grayscale(40%); }
        .icon-btn { background: transparent; border: 1px solid rgba(148,163,184,0.25); color: #cbd5e1; width: 34px; height: 34px; border-radius: 999px; cursor: pointer; }
        .icon-btn:hover { background: rgba(255,255,255,0.06); color: #f8fafc; border-color: rgba(134,239,172,0.55); }
        
        /* User Menu Dropdown */
        .user-menu-wrapper { position: relative; }
        .user-dropdown { 
          position: absolute; right: 0; top: calc(100% + 10px); 
          background: rgb(30, 41, 59); border: 1px solid rgba(80,199,89,0.4); 
          border-radius: 8px; min-width: 220px; box-shadow: 0 10px 25px rgba(0,0,0,0.3); 
          z-index: 100; padding: 8px 0;
        }
        .user-info { padding: 12px 16px; }
        .user-info .username { color: #e5e7eb; font-weight: 600; font-size: 14px; margin: 0 0 4px 0; }
        .user-info .email { color: #94a3b8; font-size: 12px; margin: 0; }
        .divider { border: 0; border-top: 1px solid rgba(148,163,184,0.2); margin: 6px 0; }
        .dropdown-item { 
          width: 100%; text-align: left; padding: 10px 16px; background: transparent; 
          border: 0; color: #cbd5e1; cursor: pointer; font-size: 13px; 
          transition: background 0.2s;
        }
        .dropdown-item:hover { background: rgba(255,255,255,0.08); }
        .dropdown-item.logout { color: #fb7185; }
        .dropdown-item.logout:hover { background: rgba(251,113,133,0.1); }

        @media (min-width: 768px) { 
          .location { display: inline-flex; }
        }

        /* Desktop - Ensure menu is visible */
        @media (min-width: 768px) {
          .nav-center { 
            display: flex !important; 
            justify-content: center; 
            align-items: center; 
            gap: 22px;
            position: static;
            background: transparent;
            border: none;
            padding: 0;
          }
        }

        /* Mobile */
        @media (max-width: 767.98px) {
          .nav-inner { grid-template-columns: auto auto 1fr; }
          .nav-toggle { display: inline-block; }
          .nav-center { 
            position: absolute; 
            left: 0; 
            right: 0; 
            top: 56px; 
            background: rgb(18,37,39); 
            border-bottom: 1px solid rgba(80,199,89,0.2); 
            display: none; 
            flex-direction: column; 
            padding: 12px 16px; 
          }
          .nav-center.open { display: flex; }
          .nav-actions { justify-content: flex-end; }
        }

      `}</style>
    </header>
  );
}

export default MarketNavbar;
